export const upsellEn = {
  'cancel-any-time': 'Cancel any time',
  'dashboard-banner-description':
    'A branded mobile app, automatic rewards, and more ways to keep guests ordering directly from you.',
  'dashboard-banner-title': 'Get 2.6× more reorders with your own mobile app',
  description:
    'One plan with every tool your restaurant needs to grow and keep guests coming back.',
  'feature-cards': {
    app: {
      body: 'Guests using your branded app reorder about 2.3x more in their first 30 days.',
      title: 'Branded mobile app',
    },
    reviews: {
      body: 'Owner automatically asks happy guests to leave reviews averaging 4.92 stars.',
      title: 'Automated Google review engine',
    },
  },
  'plan-boost': 'Boost',
  'plan-pro': 'Pro',
  price: '$199',
  'price-cadence': '/mo',
  'sheet-description':
    'Upgrade to Pro to unlock a branded mobile app, automatic rewards, and more ways to keep guests ordering directly from you.',
  'table-caption': 'All the features included with Pro:',
  'table-rows': {
    'auto-email': 'Automated email marketing',
    'auto-gbp': 'Automatically post to your Google Business Profile',
    'auto-sms': 'Automated text-message marketing',
    'branded-app': 'Your own branded mobile app',
    'branded-gift-cards': 'Sell branded gift cards',
    'catering-forms': 'Collect catering and event inquiries',
    'custom-email': 'Create and send branded email campaigns',
    'custom-website': 'An optimized website that matches your brand',
    'delivery-support': 'Delivery updates and guest support',
    'job-board': 'Add a hiring page to your website',
    listings: 'Keep your restaurant details accurate across 77+ sites',
    'live-tracking': 'Live order tracking',
    'loyalty-integrations': 'Gift card integrations',
    'online-ordering': 'Online ordering from your website',
    'order-with-google': 'Let guests order directly from Google',
    promotions: 'Create promotions and discount codes',
    'push-marketing': 'Send app push notifications',
    reputation: 'Manage and respond to customer reviews',
    reservations: 'Add reservations to your website',
    'review-engine': 'Automatically ask satisfied guests for Google reviews',
    'review-replies': 'Reply to Google reviews with AI help',
    seo: 'Rank higher on Google (SEO)',
    'unified-inbox': 'Manage guest messages in one inbox',
    upscaling: 'Enhance your menu and website photos with AI',
    'website-improver': 'Improve your website with AI',
  },
  'table-sections': {
    ai: 'AI features',
    brand: 'Brand customization',
    marketing: 'Marketing',
    ordering: 'Ordering & delivery',
    website: 'Website',
  },
  title: 'Get 2.6× more reorders with your own mobile app',
  'upgrade-cta': 'Upgrade to Pro',
  'upgrade-cta-priced': 'Upgrade to Pro for {price}/mo',
}
